<template>
  <div>
    <div class="mt-15">
      <v-dialog v-model="createWorkshopDialog" scrollable max-width="500px">
        <v-form ref="formCreateWorkshop">
          <v-card>
            <v-card-title>Add workshop</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-text-field
                v-model="workshop.company"
                label="Company"
                required
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field v-model="workshop.name" label="Name" required :rules="[rules.required]"></v-text-field>
              <v-select
                v-model="workshop.assignedTo"
                :items="staff"
                :multiple="true"
                label="Assign to..."
              ></v-select>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="workshop.date"
                    label="Date"
                    hint="DD/MM/YYYY format"
                    persistent-hint
                    prepend-icon="event"
                    v-bind="attrs"
                    v-on="on"
                    :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
              </v-menu>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="createWorkshopDialog=false">Close</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" @click="createWorkshop" text>Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="updateWorkshopDialog" scrollable max-width="500px">
        <v-form ref="formUpdateWorkshop">
          <v-card>
            <v-card-title>Update workshop</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-text-field
                v-model="workshop.company"
                label="Company"
                required
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field v-model="workshop.name" label="Name" required :rules="[rules.required]"></v-text-field>
              <v-select
                v-model="workshop.assignedTo"
                :items="staff"
                :multiple="true"
                label="Assign to..."
              ></v-select>
              <v-menu
                ref="menuUpdateDate"
                v-model="menuUpdateDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="workshop.date"
                    label="Date"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    prepend-icon="event"
                    v-bind="attrs"
                    v-on="on"
                    :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title @input="menuUpdateDate = false"></v-date-picker>
              </v-menu>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="updateWorkshopDialog=false">Close</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" @click="updateWorkshop" text>Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-card class="mx-auto">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text">Workshops</v-toolbar-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                dark
                small
                absolute
                bottom
                left
                fab
                v-on="on"
                @click="workshop=[]; createWorkshopDialog=!createWorkshopDialog"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>New workshop</span>
          </v-tooltip>
        </v-toolbar>
        <v-divider></v-divider>
        <v-alert dense text type="success" v-if="clipboardMsg">
          Workshop web link copied into
          <strong>clipboard</strong>
        </v-alert>

        <v-card-title style="padding-top:0; padding-bottom:0;">
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items="workshops"
            :headers="workshopHeaders"
            class="elevation-1"
            :items-per-page="-1"
            :search="search"
            :sort-by="['company']"
          >
            <template v-slot:item.date="{ item }">{{ item.date | moment("Do MMM YYYY") }}</template>
            <template v-slot:item.participants="{ item }">
              <div
                v-for="participant in JSON.parse(item.participants)"
                :key="participant"
                class="mt-1"
              >
                <v-chip
                  color="green lighten-4"
                  class="mb-1 mr-2 black--text"
                  label
                  small
                >{{ participant }}</v-chip>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="success" @click="editWorkshop(item.id)">edit</v-icon>
                </template>
                <span>Update location</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="deleteWorkshop(item.id)" color="error">delete</v-icon>
                </template>
                <span>Delete location</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="gray" @click="clipboardCopy(item.id)">content_copy</v-icon>
                </template>
                <span>Copy web link</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import DefaultLayout from "../layouts/DefaultLayout";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
import { hpUser } from "../classes/hpUser";
import moment from "moment";

export default {
  data() {
    return {
      createWorkshopDialog: false,
      updateWorkshopDialog: false,
      clipboardMsg: false,
      workshop: [],
      workshops: [],
      menu: false,
      menuUpdateDate: false,
      date: new Date().toISOString().substr(0, 10),
      search: null,
      hpUser: [],
      staff: [],
      workshopHeaders: [
        {
          text: "Company",
          align: "left",
          value: "company"
        },
        { text: "Name", value: "name" },
        { text: "Date", value: "date", width: "120px" },
        { text: "Participants", value: "participants" },
        { value: "action", align: "right", sortable: false, width: "105px" }
      ],
      rules: {
        required: v => !!v || "This field is required.",
        email: v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      }
    };
  },
  async created() {
    this.$emit(`update:layout`, DefaultLayout);

    const {
      data: {
        listSurveyWorkshops: { items: workshops }
      }
    } = await API.graphql(
      graphqlOperation(queries.listSurveyWorkshops, {
        filter: { isDeleted: { eq: 0 } },
        limit: 1000
      })
    );
    this.workshops = workshops;
    this.getUsers();
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    createWorkshop() {
      if (this.$refs.formCreateWorkshop.validate()) {
        let date = moment(this.workshop.date, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
        API.graphql(
          graphqlOperation(mutations.createSurveyWorkshop, {
            input: {
              company: this.workshop.company,
              name: this.workshop.name,
              participants: JSON.stringify(this.workshop.assignedTo),
              date: `${date}Z`,
              isDeleted: 0
            }
          })
        ).then(result => {
          this.workshops.push(result.data.createSurveyWorkshop);
          this.createWorkshopDialog = false;
        });
      }
    },
    updateWorkshop() {
      if (this.$refs.formUpdateWorkshop.validate()) {
        let date = moment(this.workshop.date, "DD/MM/YYYY");
        API.graphql(
          graphqlOperation(mutations.updateSurveyWorkshop, {
            input: {
              id: this.workshop.id,
              company: this.workshop.company,
              name: this.workshop.name,
              participants: JSON.stringify(this.workshop.assignedTo),
              date: `${date.format("YYYY-MM-DD")}Z`,
              isDeleted: 0
            }
          })
        ).then(result => {
          const survey = result.data.updateSurveyWorkshop;
          const index = this.workshops.findIndex(
            workshop => workshop.id === survey.id
          );

          this.workshops[index].company = survey.company;
          this.workshops[index].name = survey.name;
          this.workshops[index].date = moment(survey.date).format(
            "Do MMM YYYY"
          );
          this.workshops[index].participants = survey.participants;
          this.workshops[index].isDeleted = survey.isDeleted;
          this.updateWorkshopDialog = false;
        });
      }
    },
    editWorkshop(id) {
      API.graphql(
        graphqlOperation(queries.getSurveyWorkshop, {
          id: id
        })
      ).then(result => {
        const survey = result.data.getSurveyWorkshop;
        const index = this.workshops.findIndex(
          workshop => workshop.id === survey.id
        );

        this.workshop = {
          id: survey.id,
          company: survey.company,
          name: survey.name,
          date: moment(survey.date).format("DD/MM/YYYY"),
          assignedTo: JSON.parse(survey.participants),
          isDeleted: survey.isDeleted
        };
      });
      this.updateWorkshopDialog = true;
    },
    deleteWorkshop(id) {
      if (id) {
        API.graphql(
          graphqlOperation(mutations.updateSurveyWorkshop, {
            input: {
              id: id,
              isDeleted: 1
            }
          })
        ).then(result => {
          this.workshops = this.workshops.filter(
            workshop => workshop.id !== result.data.updateSurveyWorkshop.id
          );
        });
      }
    },
    clipboardCopy(id) {
      this.clipboardMsg = true;
      const URL = `${window.location.host}/workshop/${id}`;
      this.cliboardCopy(URL);
    },
    cliboardCopy(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    },
    getNameByEmail(email) {
      let staff = this.hpUser.filter(staff => staff.username === email);
      if (staff[0]) {
        return staff[0].firstName + " " + staff[0].lastName;
      }
    },
    async getUsers() {
      let that = this;
      that.hpUser = [];
      that.staff = [];
      let hpUserObj = new hpUser();
      that.hpUser = await hpUserObj.getUsers();
      that.hpUser = _.orderBy(that.hpUser, "firstName", "asc");
      that.hpUser.forEach(function(user) {
        that.staff.push({
          text: user.firstName + " " + user.lastName,
          value: user.firstName + " " + user.lastName
        });
      });
    }
  },
  watch: {
    date(val) {
      this.workshop.date = this.formatDate(this.date);
    }
  }
};
</script>